module.exports = __webpack_public_path__ + "static/media/viber.05289584.svg";